import React from 'react';
import styled from 'styled-components';
import { Footer } from '@ui';
import { Navbar } from './splash/Navbar';
import { selectDarkTheme } from '@utils/themes';
import { colorPalette } from '@theme';
import { useColorTheme } from '@hooks';
import { Founders } from './splash/Founders';
import { Investors } from './splash/Investors';
import { Mission } from './splash/Mission';
import { Advisors } from './splash/Advisors';

const PageWrapper = styled.div`
  background: ${({ theme }) => selectDarkTheme(theme).header};
`;
const Body = styled.div`
  background: ${({ theme }) => selectDarkTheme(theme).header};

  max-width: 1880px;
  margin: 0 auto;
`;

function setBodyBackground(color) {
  document.body.style.backgroundColor = color;
}

function About() {
  const colorTheme = useColorTheme();
  React.useEffect(() => {
    setBodyBackground(colorPalette.primary.charcoal);
    return () => {
      setBodyBackground(colorTheme.background);
    };
  }, []);

  return (
    <PageWrapper>
      <Body>
        <Navbar />
        <Mission />
        <Investors />
        <Advisors />
        <Founders />
      </Body>
      <Footer />
    </PageWrapper>
  );
}

export default About;
